import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/PageHelpers";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { Badge } from "@/components/ui/badge";

const CATS = ["Exterior", "Structure", "Landscaping", "Signage", "Windows/Doors", "Roof"];

export default function ArcRequestsPage() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ title: "", category: "Exterior", description: "" });
  const load = async () => { const { data } = await api.get("/arc"); setItems(data.items); };
  useEffect(() => { load(); }, []);
  const submit = async () => {
    if (!form.title) return toast.error("Please enter a title");
    await api.post("/arc", form);
    toast.success("Request submitted to the ARC committee");
    setForm({ title: "", category: "Exterior", description: "" });
    load();
  };
  return (
    <div>
      <PageHeader eyebrow="Committee" title="ARC Request" subtitle="Submit an architectural / exterior change request." />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <Card className="p-5 bg-white">
          <div className="overline mb-3">New request</div>
          <div className="space-y-3">
            <div><Label>Title</Label><Input data-testid="arc-title" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} placeholder="e.g. Repaint front door" /></div>
            <div>
              <Label>Category</Label>
              <Select value={form.category} onValueChange={(v) => setForm({ ...form, category: v })}>
                <SelectTrigger data-testid="arc-cat"><SelectValue /></SelectTrigger>
                <SelectContent>{CATS.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
              </Select>
            </div>
            <div><Label>Description</Label><Textarea data-testid="arc-desc" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} rows={4} /></div>
            <Button data-testid="arc-submit" onClick={submit} className="w-full rounded-full">Submit for review</Button>
          </div>
        </Card>
        <Card className="p-5 bg-white">
          <div className="overline mb-3">Your recent requests</div>
          <div className="space-y-3">
            {items.slice(0,4).map((a) => (
              <div key={a.id} className="rounded-md border border-black/5 p-3">
                <div className="flex items-center justify-between">
                  <div className="font-medium">{a.title}</div>
                  <Badge variant="outline" className="capitalize">{a.status.replaceAll("_"," ")}</Badge>
                </div>
                <div className="text-xs text-zinc-500 mt-1">{a.category}</div>
              </div>
            ))}
            {items.length === 0 && <div className="text-sm text-muted-foreground">You haven&apos;t submitted any requests.</div>}
          </div>
        </Card>
      </div>
    </div>
  );
}
